import { EmptyStateBody, Spinner, Title } from '@patternfly/react-core'
import { Table, Td, Tr } from '@patternfly/react-table'
import * as React from 'react'

import type { PdfTemplate } from '@app/domain/visit/visit.interface'
import { SmallButton } from '@app/utils/styles/small-button'

interface Props {
  isDownloading: boolean
  visitPdfs: PdfTemplate[]
  getVisitPdf: (templateId: string) => void
}

export const VisitReports = ({
  isDownloading,
  visitPdfs,
  getVisitPdf,
}: Props) => {
  const [activeDownloadId, setActiveDownloadId] = React.useState<string | null>(
    null,
  )

  React.useEffect(() => {
    if (!isDownloading) {
      setActiveDownloadId(null)
    }
  }, [isDownloading])

  {
    const onClick = React.useCallback(
      (templateId: string) => {
        setActiveDownloadId(templateId)
        getVisitPdf(templateId)
      },
      [getVisitPdf],
    )

    return (
      <>
        <Title headingLevel="h2" size="xl">
          Interaction Reports
        </Title>
        <div style={{ maxWidth: '50%' }}>
          {visitPdfs.length > 0 ? (
            <>
              <Table aria-label="Visit Reports table" isStriped>
                {visitPdfs.map((pdf) => (
                  <Tr key={pdf.id}>
                    <Td width={50}>{pdf.label ?? pdf.id}</Td>
                    <Td>
                      {' '}
                      <SmallButton
                        isDisabled={isDownloading}
                        variant="secondary"
                        onClick={() => onClick(pdf.id)}
                      >
                        Download PDF
                      </SmallButton>
                      {isDownloading && activeDownloadId === pdf.id ? (
                        <>
                          <Spinner size="md" style={{ marginLeft: 6 }} />
                        </>
                      ) : null}
                    </Td>
                  </Tr>
                ))}
              </Table>
            </>
          ) : (
            <EmptyStateBody>
              There are no visit reports configured.
            </EmptyStateBody>
          )}
        </div>
      </>
    )
  }
}
